<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-2xl font-bold text-gray-900">Planos de Negócios</h1>
    </div>

    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-8">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nome</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Mínimo de Pedidos</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Máximo de Pedidos</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Valor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="plan in plans" :key="plan.id">
            <td class="px-6 py-3 text-sm text-gray-900">{{ plan.name || '-' }}</td>
            <td class="px-6 py-3 text-sm text-gray-500">{{ plan.min_order }}</td>
            <td class="px-6 py-3 text-sm text-gray-500">{{ plan.max_order }}</td>
            <td class="px-6 py-3 text-sm font-medium text-gray-900">{{ formatMoney(plan.value) }}</td>
            <td class="px-6 py-3 text-sm">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium" :class="plan.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                {{ plan.is_active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
          </tr>
          <tr v-if="plans.length === 0">
            <td colspan="5" class="px-6 py-8 text-center text-gray-500">Nenhum plano cadastrado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { businessPlanApi } from '@/utils/api'
import { formatMoney } from '@/utils/formatters'
import { notifyError } from '@/utils/notifications'

interface BusinessPlan {
  id: number
  name: string | null
  min_order: number
  max_order: number
  value: number
  is_active: boolean
}

const plans = ref<BusinessPlan[]>([])

const loadPlans = async () => {
  try {
    const res = await businessPlanApi.getAll()
    plans.value = res.data
  } catch (error) {
    console.error('Erro ao carregar planos:', error)
    notifyError('Erro ao carregar planos')
  }
}

onMounted(() => {
  loadPlans()
})
</script>
